import AchPopoutForm from 'javascripts/components/DonateForm/AchPopoutForm';
import AmountButtonsExperiment from 'javascripts/components/DonateForm/Experiments/AmountButtonsExperiment';
import BackCacheFix from 'javascripts/behaviors/BackCacheFix';
import DonateFormAmountButtons from 'javascripts/components/DonateForm/AmountButtons';
import DonateFormAmountInput from 'javascripts/components/DonateForm/AmountInput';
import DonateFormButton from 'javascripts/components/DonateForm/Button';
import DonateFormEmailField from 'javascripts/components/DonateForm/EmailField';
import DonateFormHeader from 'javascripts/components/DonateForm/Header';
import DonateFormIhoHonoree from 'javascripts/components/DonateForm/Iho/Honoree';
import DonateFormIhoModal from 'javascripts/components/DonateForm/Iho/Modal';
import DonateFormIhoToggle from 'javascripts/components/DonateForm/Iho/Toggle';
import DonateFormSpringMemberExistsMessage from 'javascripts/components/DonateForm/SpringMemberExistsMessage';
import DonateFormSubscriptionToggle from 'javascripts/components/DonateForm/SubscriptionToggle';
import DonateFormUserCampaignFields from 'javascripts/components/DonateForm/UserCampaignFields';
import Modal from 'javascripts/behaviors/Modal';
import MonthlyGivingInlineCalculator from 'javascripts/components/MonthlyGiving/InlineCalculator';
import PaymentRequestForm from 'javascripts/components/DonateForm/PaymentRequestForm';
import PhoneNumberField from 'javascripts/components/DonateForm/PhoneNumberField';
import ReCAPTCHA from 'react-google-recaptcha';
import React from 'react';
import RecaptchaText from 'javascripts/components/RecaptchaText';
import StripeElements from 'javascripts/components/DonateForm/StripeElements';
import cx from 'classnames';
import store from 'javascripts/store.js';
import t from 'javascripts/utils/translation';
import {Elements, StripeProvider} from 'react-stripe-elements';
import {amountWithPrecisionAsRequired} from 'javascripts/utils/numberFormatter';
import {autorun, reaction} from 'mobx';
import {isEmpty} from 'lodash';
import {observer} from 'mobx-react';
import {utmCookieOrParams} from 'javascripts/utils/params';

@observer
class DonateForm extends React.Component {
  constructor(props) {
    super(props);

    store.donateForm.amount = props.amount;
    store.donateForm.campaignSlug = props.campaignSlug;
    store.donateForm.campaignPath = props.campaignPath;
    store.donateForm.campaignType = props.campaignType;
    store.donateForm.campaignId = props.campaignId;
    store.donateForm.campaignName = props.campaignName;
    store.donateForm.campaignerName = props.campaignerName;
    store.donateForm.campaignerProfileImageTag = props.campaignerProfileImageTag;
    store.donateForm.claimedGiftAid = props.claimedGiftAid;
    store.donateForm.isIho = props.acceptsIho;
    store.donateForm.onlyAcceptsIho = props.onlyAcceptsIho;
    store.donateForm.isSubscription = props.isSubscription;
    store.donateForm.plaidEnv = props.plaidEnv;
    store.donateForm.showSubscriptionOption = props.showSubscriptionOption;
    store.donateForm.isReferral = props.isReferral;
    store.donateForm.referralSource = props.referralSource;
    store.donateForm.name = props.defaultName;
    store.donateForm.surname = props.defaultSurname;
    store.donateForm.disableRecaptcha = props.disableRecaptcha;
    store.donateForm.email = props.email;
    store.donateForm.isAnonymous = props.isAnonymous;
    store.donateForm.host = props.host;
    store.donateForm.step = props.skipAmountStep ? 'payment' : 'amount';
    store.donateForm.country = props.campaignCountry;
    store.donateForm.titleOptions = props.titleOptions;
    store.donateForm.endpointPaths = props.endpointPaths;

    autorun(
      () => {
        const paymentTab = !this.props.inProgressFeaturesEnabled ? 'stripe' : store.donateForm.defaultPaymentTab;
        store.donateForm.paymentTab = paymentTab;
      }
    );

    reaction(
      () => store.donateForm.productVariant,
      () => this.setProductVariant()
    );

    store.donateForm.isUserLoggedIn = props.isUserLoggedIn;
    store.donateForm.isAlreadySpringMember = props.isAlreadySpringMember;
    store.donateForm.phoneNumber.existingValue = props.existingPhoneNumber;
    store.donateForm.phoneNumberConsentGranted = props.phoneNumberConsentGranted;
    store.donateForm.isIndividualAccount = props.isIndividualAccount;
    store.donateForm.existingMembershipCountry = props.existingMembershipCountry;
    store.donateForm.queryParams = props.queryParams;
    store.donateForm.productVariant = props.queryParams.product;
    store.donateForm.customDefaultAmounts = props.customDefaultAmounts;
    store.donateForm.minAmount = props.minAmount;
    store.donateForm.subscriptionMinAmount = props.subscriptionMinAmount;
    store.donateForm.managementMode = props.managementMode;
    store.donateForm.disableHeader = props.disableHeader;
    store.donateForm.disablePaypal = props.disablePaypal;
    store.donateForm.customDonateButtonText = props.customDonateButtonText;
    store.donateForm.disableMembershipCheck = props.disableMembershipCheck;
    store.donateForm.disablePhoneNumber = props.disablePhoneNumber;
    store.donateForm.isBpsDonateForm = props.isBpsDonateForm;
    store.donateForm.referer = props.referer;
    store.donateForm.simulateStripeWebhooks = props.simulateStripeWebhooks;
    store.donateForm.customNsIntegrationCodeFor1xDonations = props.customNsIntegrationCodeFor1xDonations;
    store.donateForm.customNsIntegrationCodeFor1xDonationsGte10k = props.customNsIntegrationCodeFor1xDonationsGte10k;
    store.donateForm.customXeroIntegrationCodeFor1xDonations = props.customXeroIntegrationCodeFor1xDonations;
    store.donateForm.customXeroIntegrationCodeFor1xDonationsGte8k = props.customXeroIntegrationCodeFor1xDonationsGte8k;
    store.donateForm.showAmountInputExperiment = props.showAmountInputExperiment;

    if(props.currentPaymentMethod) {
      store.donateForm.currentPaymentMethod = props.currentPaymentMethod;
      store.donateForm.paymentTab = props.currentPaymentMethod;
    }

    if (this.props.queryParams.defaultToggle) this.setDefaultToggle();
    store.donateForm.setCustomDefaultAmount();
    if (typeof window !== 'undefined') {
      window.AmountButtonsExperiment = AmountButtonsExperiment;
    }
  }

  componentDidMount = () => {
    BackCacheFix($(this.form));
    if(this.donateByCheck) Modal($(this.donateByCheck));
    store.donateForm.disableFormSubmit = false;
    store.donateForm.isFormMounted = true;
    store.donateForm.isOrganic = isEmpty(utmCookieOrParams());
    store.donateForm.recaptchaRef = this.recaptchaRef;
    if (this.props.acceptsIho && store.iho.designs.length === 0) store.iho.setDesigns(this.props.ihoCardDesigns);

    window.analytics.ready(() => {
      store.donateForm.analyticsUuid = window.analytics.user().anonymousId();
    });

    if (this.plaidJsScriptNotLoaded()) { this.loadPlaidJsScript(); }
  };

  plaidJsScriptNotLoaded = () => !document.getElementById('plaid-js');

  loadPlaidJsScript = () => {
    const script = document.createElement('script');
    script.defer = true;
    script.id = 'plaid-js';
    script.src = 'https://cdn.plaid.com/link/v2/stable/link-initialize.js';
    document.head.appendChild(script);
  };

  setProductVariant = () => {
    switch (store.donateForm.productVariant) {
      case 'one-time':
        store.donateForm.setProductOneTimeOnly();
        break;
      case 'monthly':
        store.donateForm.setProductMonthlyOnly();
        break;
      case 'one-time-and-monthly':
        store.donateForm.setProductOneTimeAndMonthly();
        break;
      case 'iho':
        store.donateForm.setProductIho();
        break;
    }
  };

  setDefaultToggle = () => {
    switch (this.props.queryParams.defaultToggle) {
      case 'monthly':
        store.donateForm.isSubscription = true;
        break;
      case 'one-time':
        store.donateForm.isSubscription = false;
        break;
    }
  };

  showAmountInput = () => store.donateForm.showAmountInputExperiment || this.props.queryParams.variant == 'amount-input' || ['in-honour-of', 'in-honor-of', 'water-project-sponsorship', 'water-project-sponsorship-uk'].includes(store.donateForm.campaignSlug) || store.donateForm.campaignType === 'user';

  isProfileReferral = () => store.donateForm.referralSource && store.donateForm.referralSource.sourceMechanism == 'public_profile';

  validateForm = () => (
    $(this.form).parsley().validate()
  )

  onShowNextScreen = (event, step) => {
    event.preventDefault();
    if(!this.validateForm()) { return false; }

    if(store.donateForm.onlyAcceptsIho && !store.iho.honoreeInfoIsPresent) {
      store.iho.modalOpen = true;
      return true;
    }

    store.donateForm.step = step;
  };

  onShowNextScreenForAmountStep = (event) => {
    const shouldNotDisplayGiftAidStep = store.donateForm.country == 'us' || store.donateForm.managementMode;
    this.onShowNextScreen(event, shouldNotDisplayGiftAidStep ? 'payment' : 'gift-aid');
  }

  trackPayButtonClick = (buttonTypeData) => {
    window.analytics.track(
      'Clicked Pay Button',
      {
        ...buttonTypeData,
        campaign_slug: store.donateForm.campaignSlug,
        campaign_type: this.props.campaignType,
      },
    );
  }

  paypalTabClass = () => {
    if (store.donateForm.paymentTab !== 'pay_pal') return '';
    return store.donateForm.clickedPaypalSubmit ? 'loading' : 'active';
  }

  isMoreThanOnePaymentTabToDisplay = () => (
    store.donateForm.isSubscription || store.donateForm.isPaypalAvailable
  )

  handlePaypalTabClick = (event) => {
    if (!store.donateForm.showPhoneNumberField && store.donateForm.isUserLoggedIn) {
      this.handlePaypalSubmitClick(event);
    } else {
      store.donateForm.paymentTab = 'pay_pal';
    }
  }

  handleStripeTabClick = () => {
    if (this.emailField) {
      const parsley = $(this.emailField).parsley();

      if (store.donateForm.paymentTab == 'pay_pal' && !(parsley.isValid())) {
        store.donateForm.creditCardStep = 1;
      }
    }

    store.donateForm.paymentTab = 'stripe';
  }

  handlePaypalSubmitSuccess = () => {
    store.donateForm.name = '';
    store.donateForm.surname = '';
    store.donateForm.clickedPaypalSubmit = true;
    store.donateForm.paymentTab = 'pay_pal';

    this.trackPayButtonClick({
      button_type: 'Pay Pal',
    });

    store.donateForm.createDonationForm('paypal', ({redirectUrl}) => {
      window.location = redirectUrl;
    });
  };

  handlePaypalSubmitClick = (event) => {
    if(!this.validateForm()) { return false; }

    if(store.donateForm.isSubscription && !store.donateForm.isAlreadySpringMember) {
      event.preventDefault();
      $.getJSON(`/api/v1/spring_membership/${store.donateForm.email}`, (data) => {
        store.donateForm.isAlreadySpringMember = data['is_spring_member'];

        if(!data['is_spring_member']) {
          this.handlePaypalSubmitSuccess();
        }
      });
    } else {
      this.handlePaypalSubmitSuccess();
    }
  }

  renderStripePaymentRequestForm = () => {
    if(store.donateForm.isFormMounted) {
      return (
        <StripeProvider apiKey={this.props.stripePublishableKey}>
          <Elements>
            <PaymentRequestForm
              trackPayButtonClick={this.trackPayButtonClick}
              validateForm={this.validateForm}
            />
          </Elements>
        </StripeProvider>
      );
    }
  }

  renderPaypalTab = () => {
    if(store.donateForm.clickedPaypalSubmit) {
      return (
        <div
          className='paypal-tab'
          ref={el => this.payPalTab = el}
        >
          <p className='em mb-0 pb-3'>Sending you to PayPal…</p>
        </div>
      );
    }

    if(store.donateForm.managementMode) {
      return (
        <>
          <div className='p-2 bg-grey-5 mb-2'>
            <p className='text-small text-left mb-1 leading-normal text-center'>
              Thank you for being part of the Spring community! You&apos;ll need to visit your PayPal account directly to update your payment method.&nbsp;
              <a
                href='https://support.charitywater.org/hc/en-us/articles/360023748952'
                rel='noopener noreferrer'
                target='_blank'
              >
                Click here
              </a> for directions.
              You can also switch your payment method to a credit card or bank account, which will allow for seamless maintenance in the&nbsp;future.
            </p>
          </div>
          <a
            className='button w-full'
            href={store.donateForm.endpointPaths.paypal}
          >
            Visit PayPal
          </a>
        </>
      );
    }

    return (
      <>
        <DonateFormEmailField
          ref={el => this.emailField = el}
        />

        {store.donateForm.showPhoneNumberField &&
          <PhoneNumberField />
        }

        <button
          className='w-full'
          onClick={this.handlePaypalSubmitClick}
        >
          {t('views.donate_form.submit_button_text')}
        </button>
      </>
    );
  }

  render() {
    const {
      acceptsChecks,
      defaultComment,
      errors,
      focus,
      fontStylesheetUrl,
      maxAmount,
      plaidKey,
      readOnly,
      stripePublishableKey,
    } = this.props;

    const {
      country,
      giftAidAmount,
      isSubscription,
      isSystemCampaign,
      isUserLoggedIn,
      minAmount,
      showSubscriptionOption,
      step,
      subscriptionMinAmount,
    } = store.donateForm;

    return (
      <div className={cx(`donate-form-wrapper stripe-elements step-${step}`, { 'mt-3': showSubscriptionOption })}>
        <form
          autoComplete='off'
          data-logged-in-user={isUserLoggedIn}
          data-parsley-validate={true}
          data-store-utm-params-model='donation_form'
          id={store.donateForm.formId}
          noValidate={true}
          onSubmit={store.donateForm.submitHandler}
          ref={(el) => { this.form = el; }}
        >
          {!this.props.doNotRenderIhoModal &&
            <DonateFormIhoModal />
          }
          <DonateFormSubscriptionToggle />

          {!store.donateForm.disableHeader &&
            <DonateFormHeader
              amountStepHeader={this.props.amountStepHeader}
              paymentStepHeader={this.props.paymentStepHeader}
              showAmountInput={this.showAmountInput()}
              skipAmountStep={this.props.skipAmountStep}
            />
          }

          <div className='donate-form-body'>
            {!store.donateForm.disableRecaptcha &&
              <ReCAPTCHA
                badge="inline"
                onChange={store.donateForm.handleRecaptchaSuccess}
                ref={(el) => { this.recaptchaRef = el; }}
                sitekey={recaptchaV2SiteKey}
                size="invisible"
              />
            }
            <DonateFormIhoHonoree />

            {step === 'amount' &&
              <>
                {this.showAmountInput() ?
                  <DonateFormAmountInput
                    focus={focus}
                    maxAmount={maxAmount}
                    minAmount={minAmount}
                    onShowNextScreen={this.onShowNextScreenForAmountStep}
                    readOnly={readOnly}
                    subscriptionMinAmount={subscriptionMinAmount}
                  />
                :
                  <DonateFormAmountButtons
                    key={isSubscription}
                    maxAmount={maxAmount}
                    minAmount={minAmount}
                    onShowNextScreen={this.onShowNextScreenForAmountStep}
                    readOnly={readOnly}
                    subscriptionMinAmount={subscriptionMinAmount}
                  />
                }
                {(!isSystemCampaign || this.isProfileReferral()) &&
                  <DonateFormUserCampaignFields
                    defaultComment={defaultComment}
                    errors={errors}
                  />
                }
                <DonateFormIhoToggle
                  validateForm={this.validateForm}
                />
                <DonateFormButton
                  classes='show-next-donate-screen'
                  onClick={this.onShowNextScreenForAmountStep}
                  text={isSubscription ? t('views.donate_form.donate_monthly') : t('views.donate_form.donate')}
                />
                {acceptsChecks && !isSubscription &&
                  <div className='form-footer'>
                    <a
                      className='donate-by-check h70'
                      href='#donate-by-check'
                      ref={el => this.donateByCheck = el}
                    >
                      {t('views.donate_form.give_by_check')}
                    </a>
                  </div>
                }
              </>
            }
            {step === 'gift-aid' &&
              <>
                <div className='giftaid-logo mx-auto -mt-1' />
                <p className='pb-2 px-1 text-center'>
                  <span dangerouslySetInnerHTML={{__html: t('views.donate_form.gift_aid.opt_in', {amount: amountWithPrecisionAsRequired(giftAidAmount)})}} />
                </p>
                <div className='bg-grey-10 rounded border-solid border border-grey-30 p-2 pb-1 mb-2 text-left'>
                  <div className='switch-wrapper mb-1'>
                    <label className='label-switch small pr-1'>
                      <input
                        checked={store.donateForm.claimedGiftAid}
                        onChange={() => store.donateForm.claimedGiftAid = !store.donateForm.claimedGiftAid}
                        type='checkbox'
                      />
                      <div className='checkbox' />
                    </label>
                    <label>Claim Gift Aid?</label>
                  </div>
                  <p className='text-small'>
                    By checking above, I confirm I am a UK taxpayer and I would like charity: water to treat this donation as a Gift Aid donation. I understand that if I pay less income tax and/or Capital Gains tax than the amount of Gift Aid claimed on all my donations in that year, it is my responsibility to pay any&nbsp;difference.
                  </p>
                </div>
                <DonateFormButton
                  classes='show-next-donate-screen'
                  onClick={event => this.onShowNextScreen(event, 'payment')}
                  text='Next Step'
                />
              </>
            }
            {step === 'payment' &&
              <>
                {!store.donateForm.showSpringMembershipAlreadyExistsMessage &&
                  <>
                    {this.renderStripePaymentRequestForm()}
                    <div className={cx('tab-wrapper', {hidden: country === 'uk' && !this.props.inProgressFeaturesEnabled})}>
                      <nav className='sm-tabs tabs-mini'>
                        {this.isMoreThanOnePaymentTabToDisplay() &&
                          <ul>
                            <li
                              className={cx('stripe-donate-button', {active: store.donateForm.paymentTab === 'stripe'})}
                              onClick={this.handleStripeTabClick}
                            >
                              <a
                                className='h80'
                              >
                                Card
                              </a>
                            </li>
                            {store.donateForm.isPaypalAvailable &&
                              <li
                                className={`paypal-donate-button ${this.paypalTabClass()}`}
                                onClick={this.handlePaypalTabClick}
                              >
                                <a
                                  className='h80'
                                >
                                  PayPal
                                </a>
                              </li>
                            }
                            {isSubscription && country == 'us' &&
                              <li
                                className={cx('ach-donate-button', {active: store.donateForm.paymentTab === 'plaid'})}
                                onClick={() => store.donateForm.paymentTab = 'plaid'}
                              >
                                <a className='h80'>
                                  <span className='hidden md-inline-block'> Link </span> Bank
                                </a>
                              </li>
                            }
                          </ul>
                        }
                      </nav>
                    </div>
                  </>
                }

                {store.donateForm.isFormMounted &&
                  <StripeProvider apiKey={stripePublishableKey}>
                    <Elements
                      fonts={[{ cssSrc: fontStylesheetUrl }]}
                    >
                      <StripeElements
                        donateForm={this.form}
                        trackPayButtonClick={this.trackPayButtonClick}
                        validateForm={this.validateForm}
                      />
                    </Elements>
                  </StripeProvider>
                }

                {store.donateForm.showSpringMembershipAlreadyExistsMessage ? (
                  <DonateFormSpringMemberExistsMessage />
                ) : (
                  <>
                    {{plaid: (
                      <AchPopoutForm
                        plaidKey={plaidKey}
                        trackPayButtonClick={this.trackPayButtonClick}
                      />
                    ),
                    pay_pal: (
                      this.renderPaypalTab()
                    )}[store.donateForm.paymentTab]}
                  </>
                )}
              </>
            }
          </div>
          {step === 'amount' && isSubscription &&
            <div className='inline-calculator text-xs text-cw-black p-2 border-dashed border-0 border-t border-grey-30 leading-normal'>
              <MonthlyGivingInlineCalculator
                costPerPerson={this.props.costPerPerson}
              />
            </div>
          }
        </form>
        <RecaptchaText
          classes={{'m-0 pb-1 px-2': store.donateForm.managementMode, 'pt-1': !store.donateForm.managementMode}}
        >
          <i className='cw-icon-lock' /> Secure Payment &#183;
          {' '}
        </RecaptchaText>
      </div>
    );
  }
}

export default DonateForm;
